import React from "react";
import scrollingPicture from "../assets/med-images/feel_more.jpg";
// import S1 from "../assets/med-images/s1.webp";
import S1 from "../assets/med-images/780G_s_Sync_EWIS_in_watch_SI.PNG";
import S2 from "../assets/med-images/s2.webp";
import S3 from "../assets/med-images/s3.webp";

function PictureScrolling() {
  return (
    <>
      {/* <section className="py-8 overflow-x-hidden">
        <div className="w-full grid lg:grid-cols-12 gap-8 items-center">
          <div className="px-4 lg:px-28 h-[80vh] overflow-y-auto lg:col-span-6 md:col-span-6 col-span-12">
            <h2 className="text-5xl font-normal text-gray-900 mt-5">
              Deli sistema MiniMed™ 780G 
            </h2>
            <div className="my-20">
              <div>
                <img src={S1} alt="img" className="w-72 h-auto " />
              </div>
              <div className=" flex items-center">
                <div className="h-2 w-2 rounded-full bg-red-600"></div>
                <p className="ml-1 text-dark font-light text-lg">
                Deli sistema MiniMed™ 780G 
                </p>
              </div>
              <h2 className="text-5xl font-light text-gray-900 mt-5">
                Inzulinska črpalka MiniMed™ 780G 
              </h2>
              <p className="text-gray-700 mt-7 text-lg font-light">
                Prejema podatke o ravni glukoze, izmerjene s senzorjem v realnem času, iz katerih prepračunava potrebne odmerke bazalnega inzulina in korekcije.
              </p>

              <p className="text-gray-700 mt-7 text-lg font-light">
                Inzulin dovaja samodejno**, z uporabo tehnologije SmartGuard™, pri čemer dovaja več inzulina, če je trend vaše glikemije navzgor in manj, če je trend navzdol.1
              </p>
            </div>
            <div className="my-20">
              <div>
                <img src={S2} alt="img" className="w-72 h-auto my-10" />
              </div>
              <div className=" flex items-center">
                <div className="h-2 w-2 rounded-full bg-red-600"></div>
                <p className="ml-1 text-dark font-light text-lg">
                  Deli sistema MiniMed™ 780G 
                </p>
              </div>
              <h2 className="text-5xl font-light text-gray-900 mt-5">
                Senzor Simplera Sync™ 
              </h2>
              <p className="text-gray-700 mt-7 text-lg font-light">
                Meri ravni glukoze vsakih 5 minut in podatke pošilja v črpalko. Za vstavitev senzorja (vse-v-enem) potrebujete manj kot 10 sekund in za uporabo ne zahteva zbadanja v prst **,^.
              </p>
            </div>
            <div className="my-20">
              <div>
                <img src={S3} alt="img" className="w-80 h-auto mx-auto my-10" />
              </div>
              <div className=" flex items-center">
                <div className="h-2 w-2 rounded-full bg-red-600"></div>
                <p className="ml-1 text-dark font-light text-lg">
                  Deli sistema MiniMed™ 780G 
                </p>
              </div>
              <h2 className="text-5xl font-light text-gray-900 mt-5">
                Infuzijski set Medtronic Extended
              </h2>
              <p className="text-gray-700 mt-7 text-lg font-light">
                Omogoča dovajanje inzulina iz črpalke v vaše telo s kar 96 % manj injekcij^^ in le eno menjavo seta do vsakih 7 dni. Vstavljanje je preprosto in neboleče, ter povzroča tudi manjšo količino plastičnih odpadkov<sup>2</sup>. 
              </p>
            </div>
          </div>

          <div className="lg:col-span-6 md:col-span-6 col-span-12">
            <div className="relative">
              <div className="relative z-10 flex justify-center items-center">
                <img
                  src={scrollingPicture} // Replace this with the left-side image
                  alt="Devices"
                  className="ml-auto w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section> */}


<section className="py-8">
        <div className="w-full max-w-[1700px] mx-auto grid lg:grid-cols-12 gap-8 items-cente">
          
        
          <div className="col-span-12 px-2 center">
            <h2 className="text-3xl md:text-5xl font-light text-gray-900 mb-7 text-center">
                Deli sistema MiniMed™ 780G 
              </h2>
          </div>

          <div className="lg:col-span-4 md:col-span-4 col-span-12 px-2">

            <div>
              <div className="flex justify-center">
                <img src={S1} alt="img" className="max-h-[300px] h-auto " />
              </div>
              <div className=" flex items-center">
                <div className="h-2 w-2 rounded-full bg-red-600"></div>
                <p className="ml-1 text-dark font-light text-lg">
                Deli sistema MiniMed™ 780G 
                </p>
              </div>
              <h2 className="text-3xl md:text-5xl font-light text-gray-900 mt-5">
                Inzulinska črpalka MiniMed™ 780G 
              </h2>
              <p className="text-gray-700 mt-7 text-lg font-light">
                Prejema podatke o ravni glukoze, izmerjene s senzorjem v realnem času, iz katerih prepračunava potrebne odmerke bazalnega inzulina in korekcije.
              </p>

              <p className="text-gray-700 mt-7 text-lg font-light">
                Inzulin dovaja samodejno<sup>**</sup>, z uporabo tehnologije SmartGuard™, pri čemer dovaja več inzulina, če je trend vaše glikemije navzgor in manj, če je trend navzdol<sup>1</sup>.
              </p>
            </div>
          </div>


          <div className="lg:col-span-4 md:col-span-4 col-span-12 px-2">
            <div>
              <div className="flex justify-center">
                <img src={S2} alt="img" className="max-h-[300px] h-auto" />
              </div>
              <div className=" flex items-center">
                <div className="h-2 w-2 rounded-full bg-red-600"></div>
                <p className="ml-1 text-dark font-light text-lg">
                  Deli sistema MiniMed™ 780G 
                </p>
              </div>
              <h2 className="text-3xl md:text-5xl font-light text-gray-900 mt-5">
                Senzor Simplera Sync™ 
              </h2>
              <p className="text-gray-700 mt-7 text-lg font-light">
                Meri ravni glukoze vsakih 5 minut in podatke pošilja v črpalko. Za vstavitev senzorja (vse-v-enem) potrebujete manj kot 10 sekund in za uporabo ne zahteva zbadanja v prst<sup>**,^</sup>.
              </p>
            </div>
          </div>

          <div className="lg:col-span-4 md:col-span-4 col-span-12 px-2">
            <div>
              <div className="flex justify-center">
                <img src={S3} alt="img" className="max-h-[300px] h-auto" />
              </div>
              <div className=" flex items-center">
                <div className="h-2 w-2 rounded-full bg-red-600"></div>
                <p className="ml-1 text-dark font-light text-lg">
                  Deli sistema MiniMed™ 780G 
                </p>
              </div>
              <h2 className="text-3xl md:text-5xl font-light text-gray-900 mt-5">
                Infuzijski set Medtronic Extended
              </h2>
              <p className="text-gray-700 mt-7 text-lg font-light">
                Omogoča dovajanje inzulina iz črpalke v vaše telo s kar 96 % manj injekcij<sup>^^</sup> in le eno menjavo seta do vsakih 7 dni. Vstavljanje je preprosto in neboleče, ter povzroča tudi manjšo količino plastičnih odpadkov<sup>2</sup>. 
              </p>
            </div>
          </div>

          
        </div>
      </section>
    </>
  );
}

export default PictureScrolling;
